/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import useDimensions from 'react-cool-dimensions';
import { useSetBannerHeight } from '../../context';

const style: ouiStyle.InStyleWithMediaQueries = {
  display: ouiStyle.Constants.DisplayProp.flex,
  justifyContent: ouiStyle.Constants.JustifyContentProp.center,
  alignItems: ouiStyle.Constants.AlignItemsProp.center,
  flexDirection: [ouiStyle.Constants.InFlexDirectionProp.col, undefined, undefined, ouiStyle.Constants.InFlexDirectionProp.row, undefined, undefined],
  backgroundColor: ouiStyle.Constants.Colors.accent,
  color: ouiStyle.Constants.Colors.inverted,
  paddingHorizontal: 'simple',
  paddingVertical: 'half',
  textAlign: 'center',
};

export const BannerContainer = (props: React.PropsWithChildren<{
  color?: string,
  backgroundColor?: string,
}>) => {
  const {
    color,
    backgroundColor,
    children,
  } = props;
  const css = ouiStyle.mediaQuery({
    ...ouiStyle.makeCss(style),
    color: color ?? style.color,
    backgroundColor: backgroundColor ?? style.backgroundColor,
  });
  const setBannerHeight = useSetBannerHeight();
  const { observe } = useDimensions<HTMLElement>({
    useBorderBoxSize: true,
    polyfill: ResizeObserver,
    onResize: ({ height: elementHeight }) => {
      setBannerHeight(elementHeight);
    },
  });
  return (
    <div
      ref={observe}
      css={css}
    >
      {children}
    </div>
  );
};
